import {PathUtility} from 'src/shared/constants/PathBuilder';
import {Accordion} from '@mantine/core';
import {Anchor} from 'src/design/atoms/Anchor';
import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import {Link} from 'react-router-dom';
import type {NotificationSimpleResponse} from 'src/api/ProactApiClient';
import {NotificationRecipientTypeEnum} from 'src/api/ProactApiClient';
import {AdminRoleGuard} from 'src/app/auth/AdminRoleGuard';
import {FormViewLabel} from 'src/app/forms/FormViewLabel';
import {FormViewRichTextEditor} from 'src/app/forms/FormViewRichTextEditor/FormViewRichTextEditor';

export interface NotificationsListRowProps {
  data: NotificationSimpleResponse;
}
export const NotificationsListRow = ({data}: NotificationsListRowProps) => {
  function getRecipients(type: NotificationRecipientTypeEnum): string {
    return data.recipients
      ?.filter(r => r.recipientType === type)
      .map(r => `${r.recipient.name} - ${r.recipient.email}`)
      .join(', ');
  }
  return (
    <Accordion.Item value={data.id.toString()}>
      <Accordion.Control>
        <Text fw={700}>{data.subject}</Text>
        <Text size="sm" c="dimmed" mb="md">
          ID: {data.id} | Rule: {data.notificationRule.name} | Triggered at{' '}
          {data.updatedDateTime.toString().toLongDate()}
        </Text>
      </Accordion.Control>
      <Accordion.Panel>
        <Box mb="md">
          <FormViewLabel>To</FormViewLabel>
          {getRecipients(NotificationRecipientTypeEnum.To)}
        </Box>
        <Box mb="md">
          <FormViewLabel>CC</FormViewLabel>
          {getRecipients(NotificationRecipientTypeEnum.Copy)}
        </Box>
        <Box mb="md">
          <FormViewLabel>BCC</FormViewLabel>
          {getRecipients(NotificationRecipientTypeEnum.BlindCopy)}
        </Box>
        <FormViewRichTextEditor label="Body" value={data.body} />
        <AdminRoleGuard>
          <Anchor
            component={Link}
            to={PathUtility.NotificationRuleView(data.notificationRuleId)}
            target="_blank">
            View Notification Rule
          </Anchor>
        </AdminRoleGuard>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
